// common/features/competition/constants.ts
import type { CompetitionType } from './wizard/types'

export const COMPETITION_TYPE_LABELS: Record<CompetitionType, string> = {
  season: 'Season',
  playoffs_enhanced: 'Playoffs',
  playoffs_simple: 'Simple Playoffs',
  tournament: 'Tournament',
}

export type CompetitionTypeFilterValue = CompetitionType | 'all'

export const COMPETITION_TYPE_FILTER_OPTIONS: Array<{
  value: CompetitionTypeFilterValue
  label: string
}> = [
  { value: 'all', label: 'All Types' },
  { value: 'season', label: COMPETITION_TYPE_LABELS.season },
  {
    value: 'playoffs_enhanced',
    label: COMPETITION_TYPE_LABELS.playoffs_enhanced,
  },
  { value: 'playoffs_simple', label: COMPETITION_TYPE_LABELS.playoffs_simple },
  { value: 'tournament', label: COMPETITION_TYPE_LABELS.tournament },
]
